import React, { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { FOOTER_LINKS } from "../../mock";

const applyConsent = (granted) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: granted ? "granted" : "denied",
      ad_user_data: granted ? "granted" : "denied",
      ad_personalization: granted ? "granted" : "denied",
      analytics_storage: granted ? "granted" : "denied",
    });
  }
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem("me_cookie_choice");
    if (choice === "accepted") {
      applyConsent(true);
    } else if (!choice) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const handleChoice = (value) => {
    localStorage.setItem("me_cookie_choice", value);
    applyConsent(value === "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed left-0 right-0 z-50 bg-white shadow-[0_-6px_24px_rgba(0,0,0,0.08)]"
      style={{ bottom: "var(--me-sticky-h)" }}
      role="dialog"
      aria-label="Consentement aux cookies"
    >
      <div className="max-w-[1200px] mx-auto px-6 py-5 flex flex-col md:flex-row items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="h-6 w-6 shrink-0 mt-0.5" style={{ color: "var(--me-blue)" }} />
          <p className="text-[13.5px] leading-relaxed" style={{ color: "var(--me-text)" }}>
            La société ODYS est susceptible de déposer un cookie. Pour plus d'information et
            comment modifier vos choix, consulter notre{" "}
            <a
              href={FOOTER_LINKS.cookiePolicy}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
              style={{ color: "var(--me-blue)" }}
            >
              Politique de cookie
            </a>{" "}
            et la{" "}
            <a
              href={FOOTER_LINKS.googlePrivacy}
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
              style={{ color: "var(--me-blue)" }}
            >
              politique de confidentialité de Google
            </a>
            .
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            data-testid="cookie-refuse"
            onClick={() => handleChoice("refused")}
            className="rounded-md px-5 py-2 text-[14px] font-medium transition-colors"
            style={{ backgroundColor: "#eef0f4", color: "#4b4f57" }}
          >
            Refuser
          </button>
          <button
            data-testid="cookie-accept"
            onClick={() => handleChoice("accepted")}
            className="rounded-md px-6 py-2 text-[14px] font-semibold text-white transition-colors"
            style={{ backgroundColor: "#2d55fd" }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2447e0")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#2d55fd")}
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
